import * as React from 'react';
import { More16, Share16, Header2, DropdownPopover, Outside } from '@cian/ui-kit';
import * as styles from './FolderHeader.css';

interface IProps {
  text: string;
  menu: React.ReactNode;
  shareIsAvailable: boolean;
  onClickShare(): void;
}

export function FolderHeader({ text, menu, shareIsAvailable, onClickShare }: IProps) {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <Header2>{text}</Header2>
      </div>
      {shareIsAvailable && (
        <button className={styles['button']} onClick={onClickShare}>
          <Share16 />
        </button>
      )}
      {menu && (
        <Outside onOutside={() => setMenuIsOpen(false)}>
          <button className={styles['button']} onClick={() => setMenuIsOpen(true)}>
            <DropdownPopover open={menuIsOpen} content={menu} sameWidth={false} flip={true}>
              <More16 />
            </DropdownPopover>
          </button>
        </Outside>
      )}
    </div>
  );
}
